
<div class="modal fade" id="{{dispatchFormId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">Enter Dispatch</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <ng-container *ngIf="!isMobile">
                <div class="bg-primary border-bottom border-primary-subtle px-3 py-1" style="--bs-bg-opacity: .2;">
                    <div class="row g-1 mb-1">
                        <div class="col-sm-5">
                            <div class="row g-1">
                                <div class="col-4">
                                    <label for="locCode" class="form-label">Loc</label>
                                    <input type="text" class="form-control form-control-sm" id="locCode" disabled [(ngModel)]="schedule.locCode" [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div class="col-4">
                                    <label for="startDate" class="form-label">Start Date</label>
                                    <input type="text" class="form-control form-control-sm" id="startDate" disabled value="{{schedule.beginDate }}" />
                                </div>
                                <div class="col-4">
                                    <label for="endDate" class="form-label">End Date</label>
                                    <input type="text" class="form-control form-control-sm" id="endDate" disabled value="{{schedule.endDate }}" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="row g-1">
                                <div class="col-6">
                                    <label for="commodity" class="form-label">Commodity</label>
                                    <input type="text" class="form-control form-control-sm" id="commodity" disabled value="{{schedule.commodityCode}}" />
                                </div>
                                <div class="col-6">
                                    <label for="altCommodity" class="form-label">Alt Commodity</label>
                                    <input type="text" class="form-control form-control-sm" id="altCommodity" disabled value="{{schedule.alternateCommodity}}" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="row g-1">
                                <div class="col-6">
                                    <label for="scheduleLoads" class="form-label">Loads</label>
                                    <input type="text" class="form-control form-control-sm" id="scheduleLoads" disabled value="{{schedule.loads}}" />
                                </div>
                                <div class="col-6">
                                    <label for="scheduleDispatchLoads" class="form-label">Dispatched</label>
                                    <input type="text" class="form-control form-control-sm" id="scheduleDispatchLoads" disabled value="{{schedule.dispatchedLoads}}" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row g-1 mb-1">
                        <div class="col-sm-4">
                            <label for="scheduleCustomer" class="form-label">Customer</label>
                            <input type="text" class="form-control form-control-sm" id="scheduleCustomer" disabled value="{{schedule.customer.customerName}}" />
                        </div>
                        <div class="col-sm-5">
                            <label for="scheduleLocation" class="form-label">{{scheduleLocationType}}</label>
                            <input type="text" class="form-control form-control-sm" id="scheduleLocation" disabled value="{{schedule.location.locationName}}" />
                        </div>
                        <div class="col-sm-3">
                            <label for="scheduleLocatonCity" class="form-label">City</label>
                            <input type="text" class="form-control form-control-sm" id="scheduleLocatonCity" disabled value="{{schedule.location.city}}" />
                        </div>
                    </div>
                </div>
            </ng-container>


            <div class="modal-body">
                <div class="container-fluid">

                    <ul class="text-danger" *ngIf="!formState.isValid()">
                        <li *ngIf="formState.beginDate.invalid">{{formState.beginDate.errorMessage}}</li>
                        <li *ngIf="formState.endDate.invalid">{{formState.endDate.errorMessage}}</li>
                        <li *ngIf="formState.location.invalid">{{formState.location.errorMessage}}</li>
                        <li *ngIf="formState.loads.invalid">{{formState.loads.errorMessage}}</li>
                        <li *ngIf="formState.rate.invalid">{{formState.rate.errorMessage}}</li>
                        <li *ngIf="formState.rateUnitOfMeasure.invalid">{{formState.rateUnitOfMeasure.errorMessage}}</li>
                    </ul>

                    <form #form="ngForm">
                        <div class="row g-1 mb-2">
                            <div class="col-sm-8">
                                <div class="row row-cols-lg-auto g-1 align-items-center">
                                    <div class="col-12">
                                        <label class="col-form-label-sm">Dispatch Period</label> <span class="d-inline p-1 align-middle text-danger fw-bold">*</span>
                                    </div>
                                    <div class="col-12">
                                        <div class="row g-1">
                                            <div class="col-6">
                                                <input type="date" name="dispatchBeginDate" class="form-control form-control-sm" [(ngModel)]="dispatchBeginDate" [class.border-danger]="formState.beginDate.invalid" />
                                            </div>
                                            <div class="col-6">
                                                <input type="date" name="dispatchEndDate" class="form-control form-control-sm" [(ngModel)]="dispatchEndDate" [class.border-danger]="formState.endDate.invalid" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4" *ngIf="!isMobile">
                                <div class="row row-cols-lg-auto g-1 align-items-center float-end">
                                    <label class="col-form-label-sm">Round</label>
                                    <div class="col-12">
                                        <input type="text" class="form-control form-control-sm" style="width:100px;" disabled value="{{dispatch.round}}" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Location Select-->
                        <div #locationSearchDropdown class="row mb-1 location-search-dropdown">
                            <div class="col-7">
                                <div>
                                    <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" (click)="toggleLocationSearch()">
                                        Select {{dispatchLocationType}}
                                    </button>
                                    <span class="d-inline p-1 align-middle text-danger fw-bold">*</span>
                                </div>
                                <div *ngIf="showLocationSearch">
                                    <div class="dropdown-search table-responsive border rounded shadow px-1" [ngClass]="{'w-100': isMobile}" *ngIf="!locationSearchAll">
                                        <table class="table table-sm table-borderless table-hover scrollable">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Customer
                                                        <input type="text" class="form-control form-control-sm" id="locationSearchCustomer" name="locationSearchCustomer" [(ngModel)]="locationSearchCustomer" />
                                                    </th>
                                                    <th>
                                                        {{dispatchLocationType}}
                                                        <input type="text" class="form-control form-control-sm" id="locationSearchName" name="locationSearchName" [(ngModel)]="locationSearchName" />
                                                    </th>
                                                    <th>
                                                        City
                                                        <input type="text" class="form-control form-control-sm" id="locationSearchCity" name="locationSearchCity" [(ngModel)]="locationSearchCity" />
                                                    </th>
                                                    <th>Open</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of filteredLocations; let i = index"
                                                    (click)="selectLocation(item)"
                                                    [class.table-active]="i === locationHighlightIndex">
                                                    <td>{{item.customerName}}</td>
                                                    <td>{{item.locationName}}</td>
                                                    <td>{{item.city}}</td>
                                                    <td class="text-end">{{item.openLoads}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="dropdown-search table-responsive border rounded shadow px-1" *ngIf="locationSearchAll" [ngStyle]="isMobile ? {'width' : '340px'} : {}">
                                        <table class="table table-sm table-borderless table-hover scrollable">
                                            <thead>
                                                <tr [formGroup]="locationSearchForm">
                                                    <th>
                                                        {{dispatchLocationType}}
                                                        <input type="text" class="form-control form-control-sm" formControlName="locationName" />
                                                    </th>
                                                    <th>
                                                        City
                                                        <input type="text" class="form-control form-control-sm" formControlName="city" />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of locationList; let i = index"
                                                    (click)="selectLocation(item)"
                                                    [class.table-active]="i === locationHighlightIndex">
                                                    <td>{{item.locationName}}</td>
                                                    <td>{{item.city}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="form-check float-end me-2">
                                    <input class="form-check-input" type="checkbox" id="searchAllLocations" [(ngModel)]="locationSearchAll" [ngModelOptions]="{standalone: true}">
                                    <label class="form-check-label form-label" for="searchAllLocations">
                                        <span *ngIf="!isMobile">Search</span> All {{dispatchLocationType}}s
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row g-1 mb-2">
                            <div class="col-sm-4">
                                <input type="text" class="form-control form-control-sm" id="customer" name="customer" placeholder="Customer" disabled value="{{dispatch.customer.customerName}}" />
                            </div>
                            <div class="col-sm-5">
                                <input type="text" class="form-control form-control-sm" id="location" name="location" placeholder="{{dispatchLocationType}}" disabled value="{{dispatch.location.locationName}}" [class.border-danger]="formState.location.invalid" />
                            </div>
                            <div class="col-sm-3">
                                <input type="text" class="form-control form-control-sm" id="locationCity" name="locationCity" placeholder="City" disabled value="{{dispatch.location.city}}" />
                            </div>
                        </div>

                        <!--Trucker Select-->
                        <div class="row g-1 mb-2">
                            <div #truckerSearchDropdown class="col-sm-2 trucker-search-dropdown">
                                <button class="btn btn-sm btn-secondary dropdown-toggle w-100" type="button" (click)="toggleTruckerSearch()">
                                    Select Trucker
                                </button>
                                <div *ngIf="showTruckerSearch">
                                    <div class="dropdown-search table-responsive border rounded shadow px-1">
                                        <table class="table table-sm table-borderless table-hover scrollable">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Trucker
                                                        <input type="text" class="form-control form-control-sm" id="truckerSearchName" name="truckerSearchName" [(ngModel)]="truckerSearchName" />
                                                    </th>
                                                    <th>
                                                        City
                                                        <input type="text" class="form-control form-control-sm" id="truckerSearchCity" name="truckerSearchCity" [(ngModel)]="truckerSearchCity" />
                                                    </th>
                                                    <th>
                                                        Code
                                                        <input type="text" class="form-control form-control-sm" id="truckerSearchCode" name="truckerSearchCode" [(ngModel)]="truckerSearchCode" />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of truckerList; let i = index"
                                                    (click)="selectTrucker(item)"
                                                    [class.table-active]="i === truckerHighlightIndex">
                                                    <td>
                                                        <i class="fa-solid fa-star me-1" style="color: gold;" *ngIf="isFavoriteTrucker(item)"></i>
                                                        <span class="fw-bold" [ngClass]="getComplianceClass(item)">
                                                            <i class="fa-solid fa-circle"></i>
                                                        </span>
                                                        {{item.customerName}}
                                                    </td>
                                                    <td>{{item.city}}</td>
                                                    <td>{{item.customerCode}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-5">
                                <input type="text" class="form-control form-control-sm" id="trucker" placeholder="Trucker" disabled value="{{dispatch.trucker.customerName}}" />
                                <span class="text-warning small" *ngIf="dispatch.trucker.customerId > 0 && !dispatch.trucker.hasCompliance">
                                    No compliance data available for this trucker
                                </span>
                                <span class="text-danger small" *ngIf="dispatch.trucker.hasCompliance && !dispatch.trucker.isCompliant">
                                    Selected trucker is not compliant as per Roger
                                </span>
                            </div>
                            <div class="col-sm-5">
                                <div class="row g-1">
                                    <div class="col-8">
                                        <input type="text" class="form-control form-control-sm" id="truckerCity" placeholder="City" disabled value="{{dispatch.trucker.city}}" />
                                    </div>
                                    <div class="col-4">
                                        <input type="text" class="form-control form-control-sm" id="truckerCode" placeholder="Code" disabled value="{{dispatch.trucker.customerCode}}" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row g-1" *ngIf="showOTC">
                            <div class="col-sm-5">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="otcLoads" name="otcLoads" [(ngModel)]="dispatch.isOTC" (change)="onOTCChange()" />
                                    <label class="form-check-label form-label" for="otcLoads">OTC Loads</label>
                                </div>
                            </div>
                        </div>

                        <!--Equipment Type-->
                        <div class="row g-1 mb-2" *ngIf="showEquipmentFields && equipmentTypes.length > 0">
                            <div class="col-sm-4">
                                <label class="col-form-label-sm">Equipment Type</label>
                                <select id="equipmentType" name="equipmentType" class="form-select form-select-sm" [(ngModel)]="dispatch.equipmentType" (change)="onEquipmentTypeChange()">
                                    <option value=""></option>
                                    <option *ngFor="let item of equipmentTypes" [value]="item.equipmentCode">{{item.description}}</option>
                                </select>
                            </div>
                            <div class="col-sm-3">
                                <label class="col-form-label-sm">Default Weight</label>
                                <input type="text" class="form-control form-control-sm" id="equipmentWeight" disabled [value]="dispatch.equipmentWeight" />
                            </div>
                            <div class="col-sm-2">
                                <label class="col-form-label-sm">Weight UOM</label>
                                <input type="text" class="form-control form-control-sm" id="equipmentWeightUOM" disabled [value]="dispatch.equipmentWeightUOM" />
                            </div>
                        </div>

                        <!--Loads Rate-->
                        <div class="row g-1 mb-2">
                            <div class="col-sm-7">
                                <div class="row g-1">
                                    <div class="col-7">
                                        <div class="row g-1">
                                            <div class="col-4">
                                                <label class="col-form-label-sm">Loads</label> <div class="d-inline p-1 align-middle text-danger fw-bold">*</div>
                                                <input type="number" class="form-control form-control-sm" id="loads" [min]="0"
                                                       (keydown)="preventNegativeKey($event)" (input)="preventNegative($event)" [disabled]="dispatch.isOTC"
                                                       name="loads" [(ngModel)]="dispatchLoads" [class.border-danger]="formState.loads.invalid" />
                                            </div>
                                            <div class="col-4">
                                                <label class="col-form-label-sm">Rate</label>
                                                <input type="number" class="form-control form-control-sm" id="rate" step="0.01" min="0" (keypress)="preventNegativeKey($event)"
                                                       name="rate" [(ngModel)]="dispatchRate" [class.border-danger]="formState.rate.invalid" />
                                            </div>
                                            <div class="col-4">
                                                <label class="col-form-label-sm">&nbsp;</label>
                                                <input type="text" class="form-control form-control-sm" id="currency" name="currenty" value="{{dispatch.currency}}" disabled />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <label class="col-form-label-sm">&nbsp;</label>
                                        <select id="rateUom" name="rateUom" class="form-select form-select-sm" [(ngModel)]="rateUnitOfMeasure" [class.border-danger]="formState.rateUnitOfMeasure.invalid">
                                            <option value=""></option>
                                            <option *ngFor="let item of uomList" value="{{item.value}}">{{item.text}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-5">
                                <div class="row g-1">
                                    <div class="col-6">
                                        <label class="col-form-label-sm">Origin Load #</label>
                                        <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal" attr.data-bs-target="#{{loadBankApplyFormId}}" title="find load number" (click)="openLoadBank(0)">
                                            <i class="fa-regular fa-rectangle-list"></i>
                                        </a>
                                        <input type="text" class="form-control form-control-sm" id="loadNumber" name="loadNumber" [(ngModel)]="dispatch.loadNumber" />
                                    </div>
                                    <div class="col-6">
                                        <label class="col-form-label-sm">Dest Unload # </label>
                                        <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal" attr.data-bs-target="#{{loadBankApplyFormId}}" title="find unload number" (click)="openLoadBank(1)">
                                            <i class="fa-regular fa-rectangle-list"></i>
                                        </a>
                                        <input type="text" class="form-control form-control-sm" id="unloadNumber" name="unloadNumber" [(ngModel)]="dispatch.unloadNumber" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Mobile Account-->
                        <div class="row g-1 mt-1 mb-2" *ngIf="isMobile">
                            <div class="col-12">
                                <label class="col-form-label-sm">Account</label>
                                <select id="mobileAccount" name="mobileAccount" class="form-select form-select-sm" [(ngModel)]="dispatch.accountId">
                                    <option value="0"></option>
                                    <option *ngFor="let item of accountList" value="{{item.value}}">{{item.text}}</option>
                                </select>
                            </div>
                        </div>

                        <!--Contracts and Account-->
                        <div class="row mb-2">
                            <div #contractSearchDropdown class="col-sm-8 contract-search-dropdown">
                                <div class="row row-cols-lg-auto g-1 align-items-center">
                                    <div class="col-12">
                                        <button class="btn btn-sm btn-secondary dropdown-toggle w-100" type="button" (click)="getContracts()">
                                            Select Contract
                                        </button>
                                        <div *ngIf="showContractSearch">
                                            <div class="dropdown-search table-responsive border rounded shadow px-1" style="height: 150px;">
                                                <table class="table table-sm table-borderless table-hover scrollable">
                                                    <thead>
                                                        <tr>
                                                            <th>Contract #</th>
                                                            <th>Begin Date</th>
                                                            <th>End Date</th>
                                                            <th class="text-center" *ngIf="!isMobile">Qty</th>
                                                            <th class="text-center" *ngIf="!isMobile">Open</th>
                                                            <th class="text-center">Loads</th>
                                                            <th class="text-center">Open</th>
                                                            <th *ngIf="!isMobile">Cust Contract</th>
                                                            <th *ngIf="!isMobile">Cust</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let contract of contractList; let i = index"
                                                            (click)="selectContract(contract)"
                                                            [class.table-active]="i === contractHighlightIndex">
                                                            <td>{{contract.contractNumber}}</td>
                                                            <td>{{contract.periodBeginDate}}</td>
                                                            <td>{{contract.periodEndDate}}</td>
                                                            <td class="text-end" *ngIf="!isMobile">
                                                                {{contract.quantity}}
                                                            </td>
                                                            <td class="text-end" *ngIf="!isMobile">
                                                                {{contract.openQuantity}}
                                                            </td>
                                                            <td class="text-end">{{contract.loads}}</td>
                                                            <td class="text-end">{{contract.openLoads}}</td>
                                                            <td *ngIf="!isMobile">{{contract.customerContract}}</td>
                                                            <td *ngIf="!isMobile">{{contract.customerCode}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-5">
                                        <input type="text" id="contractNumber" class="form-control form-control-sm" placeholder="Contract Number" disabled value="{{dispatch.contract.contractNumber}}" />
                                    </div>
                                    <div class="col-5">
                                        <input type="text" id="customerContract" class="form-control form-control-sm" placeholder="Customer Contract" disabled value="{{dispatch.contract.customerContract}}" />
                                    </div>
                                    <div class="col-2">
                                        <a href="#" title="remove contract" (click)="removeContract()">
                                            <i class="fa-solid fa-xmark"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4" *ngIf="!isMobile">
                                <div class="row row-cols-lg-auto g-1 align-items-center float-end">
                                    <label class="col-form-label-sm">Account</label>
                                    <div class="col-12">
                                        <select id="account" name="account" class="form-select form-select-sm" [(ngModel)]="dispatch.accountId">
                                            <!--<option value="0"></option>-->
                                            <option *ngFor="let item of accountList" value="{{item.value}}">{{item.text}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Notes Fields-->
                        <div class="col-sm-3" *ngIf="isMobile">
                            <div style="display: flex; align-items: center;">
                                <label class="col-form-label-sm" style="margin-right: 10px;">Notes</label>
                                <ng-container>
                                    <div *ngIf="!isShowNotes" (click)="showHideNotes()">
                                        <svg enable-background="new 0 0 32 32" height="16px" version="1.1" viewBox="0 0 32 32" width="16px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                                        <g id="background"><rect fill="none" height="32" width="32" /></g>
                                        <g id="arrow_x5F_down"><polygon points="2.002,10 16.001,24 30.002,10" /></g>
                                </svg>
                                    </div>
                                    <div *ngIf="isShowNotes" (click)="showHideNotes()">
                                        <svg enable-background="new 0 0 32 32" width="16px" height="16px" version="1.1" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                                        <g id="backbord"><rect fill="none" height="32" width="32" /></g>
                                        <g id="arrow_x5F_up"><polygon points="30,22 16.001,8 2.001,22" /></g>
                                </svg>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <ng-container *ngIf="!isMobile || isShowNotes">
                            <div class="row g-2 mb-2">
                                <div class="col-sm-4">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label class="col-form-label-sm">{{loadType}} Notes:</label>
                                        <div class="fs-12">{{dispatch.loadNotes?.length}}/{{loadNotesMaxLength}}</div>
                                    </div>
                                    <textarea class="form-control form-control-sm" id="loadNotes" name="loadNotes" rows="5"
                                              [(ngModel)]="dispatch.loadNotes" [ngModelOptions]="{standalone: true}" (input)="validateLength('loadNotes', loadNotesMaxLength)"></textarea>
                                    <div *ngIf="loadNotesError" class="text-danger">
                                        Maximum {{loadNotesMaxLength}} characters allowed.
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label class="col-form-label-sm">Location Notes:</label>
                                        <div class="fs-12">{{dispatch.locationNotes?.length}}/{{locationNotesMaxLength}}</div>
                                    </div>
                                    <textarea class="form-control form-control-sm" id="locationNotes" name="locationNotes" rows="5"
                                              [(ngModel)]="dispatch.locationNotes" [ngModelOptions]="{standalone: true}" (input)="validateLength('locationNotes', locationNotesMaxLength)"></textarea>
                                    <div *ngIf="locationNotesError" class="text-danger">
                                        Maximum {{locationNotesMaxLength}} characters allowed.
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label class="col-form-label-sm">Internal Notes:</label>
                                        <div class="fs-12">{{dispatch.internalNotes?.length}}/{{internalNotesMaxLength}}</div>
                                    </div>
                                    <textarea class="form-control form-control-sm" id="internalNotes" name="internalNotes" rows="5"
                                              [(ngModel)]="dispatch.internalNotes" [ngModelOptions]="{standalone: true}" (input)="validateLength('internalNotes', internalNotesMaxLength)"></textarea>
                                    <div *ngIf="internalNotesError" class="text-danger">
                                        Maximum {{internalNotesMaxLength}} characters allowed.
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!--Loads Breakout-->
                        <div class="row g-2">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="loadBreakout" name="loadBreakout" [(ngModel)]="loadsBreakout">
                                <label class="form-check-label form-label" for="loadBreakout">
                                    Breakout Loads By Day
                                </label>
                            </div>
                        </div>
                        <div class="row g-2" *ngIf="dispatch.loadBreakout">
                            <div class="col-sm-8 border border-rounded table-responsive load-breakout" [ngClass]="{'w-100': isMobile}">
                                <table class="table table-sm table-borderless" style="table-layout: auto; width: auto; min-width: 100%;">
                                    <thead>
                                        <tr>
                                            <th>{{dispatch.useDeliveryDate ? 'Delivery Date' : 'Load Date'}}</th>
                                            <th>Day</th>
                                            <th>Delivery Time</th>
                                            <th>Loads</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let loadDay of dispatch.loadBreakoutList; index as i">
                                            <td><input type="date" class="form-control form-control-sm" style="min-width: 130px;" [name]="'loadDate-' + i" [(ngModel)]="loadDay.loadDate" [ngModelOptions]="{standalone: true}" (blur)="setLoadDayOfWeek(loadDay)" /></td>
                                            <td><input type="text" class="form-control form-control-sm" style="min-width: 80px;" disabled [name]="'day-' + i" value="{{loadDay.dayOfWeek}}" /></td>
                                            <td>
                                                <select class="form-select form-select-sm" style="min-width: 120px;" [name]="'deliveryTime-' + i" [(ngModel)]="loadDay.deliveryTime" [ngModelOptions]="{standalone: true}">
                                                    <option *ngFor="let slot of timeSlots" [value]="slot">{{slot}}</option>
                                                </select>
                                            </td>
                                            <td><input type="number" class="form-control form-control-sm" style="min-width: 70px;" [name]="'loads-' + i" [(ngModel)]="loadDay.loads" [ngModelOptions]="{standalone: true}" (blur)="calculateBreakoutTotal()" /></td>
                                            <td class="text-center align-middle"><a href="#" (click)="deleteLoadDay(i)"><i class="fa-solid fa-trash-can fa-lg"></i></a></td>
                                        </tr>
                                        <tr *ngIf="dispatch.loadBreakoutList.length > 0">
                                            <td></td>
                                            <td></td>
                                            <td class="fw-bold text-end align-middle">Total:</td>
                                            <td><input type="text" class="form-control form-control-sm fw-bold" style="min-width: 70px;" disabled value="{{breakoutTotal}}" /></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-4">
                                <button type="button" class="btn btn-sm btn-secondary me-2" (click)="addLoadDay()">Add Day</button>
                                <button type="button" class="btn btn-sm btn-secondary" (click)="clearLoadDays()">Clear All</button>
                                <div class="form-check mt-2">
                                    <input class="form-check-input" type="checkbox" value="" id="useDeliveryDate" name="useDeliveryDate" [(ngModel)]="dispatch.useDeliveryDate">
                                    <label class="form-check-label form-label" for="useDeliveryDate">
                                        Use Delivery Date
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>

            <div class="modal-footer">
                <div class="d-block w-100">
                    <button type="button" class="btn btn-sm btn-danger float-start" (click)="deleteDispatch()" *ngIf="!isMobile && !isNew && formStatus == FormStatus.Normal">Delete Dispatch</button>
                    <div class="float-end" *ngIf="formStatus == FormStatus.Delete || formStatus == FormStatus.Deleting">
                        <button type="button" class="btn btn-sm btn-danger me-2" (click)="confirmDelete()" *ngIf="formStatus == FormStatus.Delete">Confirm Delete</button>
                        <button type="button" class="btn btn-sm btn-danger me-2" disabled *ngIf="formStatus == FormStatus.Deleting">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            <span>Deleting...</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary" (click)="cancelDelete()" [disabled]="formStatus == FormStatus.Deleting">Cancel Delete</button>
                    </div>
                    <div class="float-end" *ngIf="formStatus == FormStatus.Normal || formStatus == FormStatus.Saving">
                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 100px;" (click)="onSaveClick(false)" *ngIf="formStatus == FormStatus.Normal" title="Ctrl+S">Save &amp; Close</button>
                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 100px;" (click)="onSaveClick(true)" *ngIf="formStatus == FormStatus.Normal" title="Ctrl+Shift+S">Save &amp; New</button>
                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 100px;" disabled *ngIf="formStatus == FormStatus.Saving">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            <span>Saving...</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary" style="width: 100px;" data-bs-dismiss="modal" [disabled]="formStatus == FormStatus.Saving" title="Esc">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<load-bank-apply [parameters]="loadBankApplyParameters" [loadBankApplyFormId]="loadBankApplyFormId" [isMobile]="isMobile" (loadBankApply)="applyLoadNumber($event)"></load-bank-apply>